<template>
  <div class="input-wrapper">
    <InputText v-bind="$attrs" @input="updateValue" :value="value"/>
    <button v-if="notEmpty()" @click="effacerCritereChamp()" class="clear-button-date"> X </button>
  </div>
</template>

<script>
import InputText from "primevue/inputtext";

export default {
    name: 'InputTextCustom',
    extends: InputText,
    data() {
        return {
            value: this.modelValue,
            deleted: false
        };
    },
    methods: {
        getDeleted(){
            return this.deleted;
        },
        setDeleted(deleted){
            this.deleted = deleted;
        },
        updateValue(event){
          this.deleted = false;
            const newValue = event.target.value;
            this.value = newValue;
            this.$emit('update:modelValue', newValue);
        },
        effacerCritereChamp(){
          this.deleted = true;
            this.value = null;
            this.$emit('update:modelValue', this.value);
        },
        notEmpty(){
            if(this.value == null ||this.value == undefined){
                return false;
            }else {
                return true;
            }
        }
    },
    watch: {
        modelValue(newValue){
            this.value = newValue;
        }
    }

}

</script>
